/** Shared copy when LUFE soft-fails in origination steps 1–2. */
export const LUFE_DEGRADED_TOAST_TITLE =
  'LUFE no disponible o demoró en responder. Podés continuar y cargar los documentos de forma manual.';

export const LUFE_DEGRADED_HEADER = 'x-lufe-degraded';

/**
 * Detects soft-fail degrade signal from BFF/MS (`X-Lufe-Degraded: true`).
 * Axios normalizes header names to lowercase.
 */
export function isLufeDegradedResponse(response: {
  success?: boolean;
  headers?: Record<string, unknown>;
} | null | undefined): boolean {
  if (!response?.headers) {
    return false;
  }
  const headers = response.headers;
  const value =
    headers[LUFE_DEGRADED_HEADER] ??
    headers['X-Lufe-Degraded'] ??
    headers['X-LUFE-DEGRADED'];
  if (Array.isArray(value)) {
    return value.some((v) => String(v).toLowerCase() === 'true');
  }
  return String(value ?? '').toLowerCase() === 'true';
}

/** Toast when fetch failed OR soft-degraded (including empty [] with header). */
export function shouldShowLufeDegradedToast(response: {
  success?: boolean;
  headers?: Record<string, unknown>;
} | null | undefined): boolean {
  if (!response) {
    return true;
  }
  if (!response.success) {
    return true;
  }
  return isLufeDegradedResponse(response);
}
